<template>
  <mp-box v-if="isShowCallWidget" ref="voiceWidget" position="relative">
    <!-- // DEFAULT WIDGET -->
    <mp-flex
      v-if="!isMiniSize"
      id="drag-element"
      ref="widget"
      direction="column"
      justify="center"
      align-items="center"
      :width="widthDefaultWidget"
      height="auto"
      z-index="1000000"
      background="dark"
      position="fixed"
      bottom="6"
      right="6"
      rounded="md"
      shadow="lg"
    >
      <mp-box id="drag-handle" mt="2" mb="1">
        <mp-icon
          name="drag"
          color="gray.600"
          transform="rotate(90deg)"
          cursor="move"
        />
      </mp-box>
      <mp-flex justify="space-between" px="4" width="full">
        <mp-text
          :color="onGenerateConnectionStatusColor(connectionStatus)"
          font-weight="semibold"
          font-size="lg"
        >
          {{ onGenerateConnectionStatusName(connectionStatus) }}
        </mp-text>
        <mp-flex
          v-if="
            connectionStatus === 'CALLING' ||
            connectionStatus === 'RINGING' ||
            connectionStatus === 'ON_CALL'
          "
          gap="4"
        >
          <mp-icon
            name="minus"
            color="white"
            cursor="pointer"
            variant="fill"
            @click.native="onClickButtonMinimize"
          />
          <!-- <mp-icon
              name="full-screen"
              color="white"
              cursor="pointer"
              @click.native="onClickButtonFullScreen"
            /> -->
        </mp-flex>
        <mp-icon
          v-if="
            connectionStatus === 'UNANSWERED' ||
            connectionStatus === 'REJECTED' ||
            connectionStatus === 'CALL_ENDED'
          "
          name="close"
          color="white"
          cursor="pointer"
          @click.native="onClickButtonCloseWidget"
        />
      </mp-flex>

      <mp-flex direction="column" width="full" gap="4" p="4">
        <mp-flex
          v-if="connectionStatus !== 'USER_INITIATED'"
          gap="1"
          align-items="center"
        >
          <mp-icon
            :name="icon.name"
            :size="icon.size"
            :color="icon.color"
            :transform="icon.transform"
          />
          <mp-text color="white" font-size="sm">{{
            callDuration.value
          }}</mp-text>
        </mp-flex>

        <!-- position="absolute"
        top="20px" -->
        <mp-box>
          <mp-box
            v-if="connectionStatus === 'USER_INITIATED'"
            py="10px"
            px="16px"
            bg="gray.400"
            border-radius="6px 6px 0 0"
            mb="-1"
          >
            <mp-text color="white" font-size="sm" text-align="left">
              Waiting time {{ callIncoming.value }}
            </mp-text>
          </mp-box>
          <mp-flex
            position="relative"
            direction="column"
            align-items="center"
            gap="3"
            bg="gray.600"
            rounded="md"
            p="4"
          >
            <mp-box position="absolute" top="3" right="3">
              <VoiceWaveIcon
                v-if="isShowVoiceWaveIcon"
                ref="voiceWaveIcon"
                :is-start="isShowWaveAnimation"
              />
            </mp-box>
            <mp-box width="50px" height="50px">
              <mp-flex
                class="mp-avatar-initial"
                position="absolute"
                align="center"
                justify="center"
                background="green.400"
                rounded="full"
                width="50px"
                height="50px"
                z-index="2"
              >
                <mp-text font-weiight="semibold" font-size="lg" color="white">{{
                  generateInitials(data.user.fullname)
                }}</mp-text>
              </mp-flex>
            </mp-box>
            <mp-box
              id="pulseCircle"
              ref="pulseCircle"
              width="50px"
              height="50px"
              rounded="full"
              top="15px"
              background="white"
              position="absolute"
            >
            </mp-box>
            <mp-flex direction="column" width="full">
              <mp-text
                color="white"
                font-size="sm"
                font-weight="semibold"
                text-align="center"
                >{{ data.user.fullname }}</mp-text
              >
              <mp-text color="gray.100" font-size="sm" text-align="center">
                {{ data.user.phone }}
              </mp-text>
            </mp-flex>
          </mp-flex>
        </mp-box>

        <!-- <mp-box
            v-if="localConnectionCode"
            p="4"
            backgound="gray.50"
            border-radius="10px"
            overflow="auto"
          >
            <mp-text size="sm" color="white" mb="2" text-align="center">
              {{
                !data.connectionCodeOffer
                  ? 'Share this code to let others join:'
                  : 'Share this answer code with the host:'
              }}
            </mp-text>
            <mp-input v-model="localConnectionCode"> </mp-input>
          </mp-box>
          <mp-box
            v-if="!data.connectionCodeOffer"
            p="4"
            backgound="gray.50"
            border-radius="10px"
            overflow="auto"
          >
            <mp-text size="sm" color="white" mb="2" text-align="center">
              Paste answer code to connect a call:
            </mp-text>
            <mp-input v-model="inputCode"> </mp-input>
            <mp-button
              mt="2"
              width="full"
              :is-disabled="!inputCode"
              @click="onCompleteConnection"
            >
              Complete connection
            </mp-button>
          </mp-box> -->

        <mp-flex v-if="isShowButtonResponseIncomingCall" gap="2">
          <mp-button
            justify="center"
            align-items="center"
            gap="2"
            width="full"
            height="38px"
            px="3"
            border="none"
            rounded="md"
            background="red.400"
            transition="box-shadow 250ms ease"
            :_hover="{ background: 'red.500' }"
            :_focus="{
              outline: 'none',
              background: 'red.500',
              border: '1px solid var(--colors-red-50)',
              boxShadow: '0px 0px 0px 2px var(--colors-red-400)',
            }"
            :_active="{ background: 'red.700' }"
            :is-disabled="isLoadingButtonResponseCall"
            @click="onClickButtonDeclineCall"
          >
            <mp-icon
              name="phone"
              variant="fill"
              size="sm"
              color="white"
              transform="rotate(135deg)"
            />
            <mp-text font-weight="semibold" color="white">Decline</mp-text>
          </mp-button>
          <mp-button
            justify="center"
            align-items="center"
            gap="2"
            width="full"
            height="38px"
            px="3"
            border="none"
            rounded="md"
            background="green.400"
            transition="box-shadow 250ms ease"
            :_hover="{ background: 'green.500' }"
            :_focus="{
              outline: 'none',
              background: 'green.400',
              border: '1px solid var(--colors-green-50)',
              boxShadow: '0px 0px 0px 2px var(--colors-green-400)',
            }"
            :_active="{ background: 'green.700' }"
            :is-disabled="isLoadingButtonResponseCall"
            @click="onClickButtonAcceptCall"
          >
            <mp-icon name="phone" variant="fill" size="sm" color="white" />
            <mp-text font-weight="semibold" color="white">Accept</mp-text>
          </mp-button>
        </mp-flex>

        <mp-flex v-if="isShowButtonMicAndEndCall" justify="center" gap="4">
          <VoiceButtonDropdown
            :variant="microphone.isMuted ? 'mute' : 'unmute'"
            :label="microphone.isMuted ? 'Unmute' : 'Mute'"
            :is-speaking="isShowMicAnimation"
            @click="onClickButtonMuteUnmute"
          >
            <mp-flex direction="column" width="full">
              <mp-box px="3" py="1">
                <mp-text color="gray.400" text-align="left" font-size="sm">
                  MICROPHONE
                </mp-text>
              </mp-box>
              <mp-box
                v-if="isMicrophoneDetected && microphone.isGranted"
                px="3"
                py="1.5"
              >
                <mp-text color="gray.100">
                  {{
                    device.microphone.selected
                      ? device.microphone.selected.title
                      : 'No device selected'
                  }}
                </mp-text>
                <mp-text font-size="sm" color="gray.400">
                  {{
                    device.microphone.selected
                      ? device.microphone.selected.description
                      : 'Unknown'
                  }}
                </mp-text>
              </mp-box>
              <mp-flex v-if="!isMicrophoneDetected" gap="2" px="3" py="1.5">
                <mp-icon
                  name="warning-triangle"
                  variant="fill"
                  color="orange.400"
                />
                <mp-text color="gray.100">No microphone detected</mp-text>
              </mp-flex>
              <mp-flex v-if="!microphone.isGranted" gap="2" px="3" py="1.5">
                <mp-icon
                  name="warning-triangle"
                  variant="fill"
                  color="orange.400"
                />
                <mp-text color="gray.100">Need permission</mp-text>
              </mp-flex>
            </mp-flex>
            <mp-divider />
            <mp-flex direction="column" width="full">
              <mp-box px="3" py="1">
                <mp-text color="gray.400" text-align="left" font-size="sm">
                  SPEAKER
                </mp-text>
              </mp-box>
              <mp-box
                v-if="isSpeakerDetected && camera.isGranted"
                px="3"
                py="1.5"
              >
                <mp-text color="gray.100">
                  {{
                    device.speaker.selected
                      ? device.speaker.selected.title
                      : 'No device selected'
                  }}
                </mp-text>
                <mp-text font-size="sm" color="gray.400">
                  {{
                    device.speaker.selected
                      ? device.speaker.selected.description
                      : 'Unknown'
                  }}
                </mp-text>
              </mp-box>
              <mp-flex v-if="!isSpeakerDetected" gap="2" px="3" py="1.5">
                <mp-icon
                  name="warning-triangle"
                  variant="fill"
                  color="orange.400"
                />
                <mp-text color="gray.100">No speaker detected</mp-text>
              </mp-flex>
              <mp-flex v-if="!camera.isGranted" gap="2" px="3" py="1.5">
                <mp-icon
                  name="warning-triangle"
                  variant="fill"
                  color="orange.400"
                />
                <mp-text color="gray.100">No permission</mp-text>
              </mp-flex>
            </mp-flex>
          </VoiceButtonDropdown>
          <VoiceButton
            variant="decline"
            label="End"
            @click="onClickButtonEndCall"
          />
        </mp-flex>

        <mp-button
          v-if="isShowButtonCallAgain"
          justify="center"
          align-items="center"
          gap="2"
          width="full"
          height="38px"
          px="3"
          rounded="md"
          background="green.400"
          transition="box-shadow 250ms ease"
          :_hover="{
            background: 'green.500',
          }"
          :_focus="{
            outline: 'none',
            background: 'green.400',
            border: '1px solid var(--colors-green-50)',
            boxShadow: '0px 0px 0px 2px var(--colors-green-400)',
          }"
          :_active="{
            background: 'green.700',
          }"
          @click="onClickButtonCallAgain"
        >
          <mp-icon name="phone" variant="fill" size="sm" color="white" />
          <mp-text font-weight="semibold" color="white">Call again</mp-text>
        </mp-button>

        <mp-flex v-if="connectionStatus === 'CALL_ENDED'" justify="center">
          <mp-button variant="link" @click="onClickButtonCloseWidget">
            <mp-text width="full" font-size="md" color="white">
              Close ({{ closeTimer.seconds }}s)
            </mp-text>
          </mp-button>
        </mp-flex>
      </mp-flex>
    </mp-flex>

    <!-- // MINI WIDGET -->
    <mp-flex
      v-if="isMiniSize"
      id="drag-element"
      ref="widget"
      direction="row"
      justify="flex-start"
      align-items="center"
      gap="3"
      :width="widthMiniWidget"
      height="auto"
      z-index="1000000"
      background="dark"
      position="fixed"
      bottom="6"
      right="6"
      rounded="100px"
      shadow="lg"
      py="2"
      px="3"
      @mouseover.native="isShowActionButton = true"
      @mouseleave.native="isShowActionButton = false"
    >
      <mp-box id="drag-handle">
        <mp-icon
          name="drag"
          color="gray.600"
          transform="rotate(0deg)"
          cursor="move"
        />
      </mp-box>
      <mp-flex
        v-if="!isShowActionButton"
        justify="space-between"
        align-items="center"
        width="full"
      >
        <mp-flex direction="column">
          <mp-flex gap="1" align-items="center">
            <mp-text
              :color="onGenerateConnectionStatusColor(connectionStatus)"
              font-weight="semibold"
              font-size="lg"
            >
              {{ onGenerateConnectionStatusName(connectionStatus) }}
            </mp-text>
            <mp-badge variant="solid" variant-color="green" size="sm">
              {{ callDuration.value }}
            </mp-badge>
          </mp-flex>

          <mp-text color="gray.100" font-size="sm">{{
            data.user.fullname
          }}</mp-text>
        </mp-flex>
        <VoiceWaveIcon
          v-if="isShowVoiceWaveIcon"
          :is-start="isShowWaveAnimation"
        />
      </mp-flex>
      <mp-flex
        v-if="isShowActionButton"
        justify="center"
        gap="4"
        width="calc(100% - 48px)"
      >
        <VoiceButton
          :variant="microphone.isMuted ? 'mute' : 'unmute'"
          @click="onClickButtonMuteUnmute"
        />
        <VoiceButton icon="picture-in-picture" @click="onClickButtonMinimize" />
      </mp-flex>
    </mp-flex>
  </mp-box>
</template>

<script>
import anime from 'animejs'
import { Draggable } from '@neodrag/vanilla'
import { mapState } from 'vuex'
import VoiceButton from './VoiceButton'
import VoiceButtonDropdown from './VoiceButtonDropdown'
import VoiceWaveIcon from './VoiceWaveIcon'
import { CALLS_URL, CALLS_VOICE_URL } from '~/assets/variables/endpoints'
import { validTokenCookie } from '~/utils/general'

export default {
  name: 'CallWidget',
  components: {
    VoiceButton,
    VoiceButtonDropdown,
    VoiceWaveIcon,
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        status: '',
        user: {
          avatar: '',
          fullname: '',
          phone: '',
        },
      }),
    },
  },

  data() {
    return {
      // widget style
      isShowCallWidget: false,
      pulseAnimation: '',
      drag: null,
      dragEl: null,
      containerEl: null,
      handleEl: null,
      widthDefaultWidget: '360px',
      widthMiniWidget: '220px',
      audioCalling: null,
      audioCallEnded: null,

      // call info
      icon: {
        name: 'phone',
        color: 'gray.400',
        size: 'sm',
        transform: 'rotate(0deg)',
      },
      callIncoming: {
        timer: '',
        value: '00:00',
        seconds: 0,
      },
      callDuration: {
        timer: '',
        value: '00:00',
        seconds: 0,
      },
      closeTimer: {
        timer: '',
        seconds: 15,
      },
      callingTimer: {
        timer: '',
        seconds: 15,
      },
      device: {
        isCanSelectDevice: false,
        microphone: {
          selected: null,
          value: null,
          list: [],
        },
        speaker: {
          selected: null,
          value: null,
          list: [],
        },
      },
      microphone: {
        isGranted: true,
        isMuted: false,
      },
      camera: {
        isGranted: true,
        isMuted: false,
      },

      // call toggle
      isVideoActive: false,
      isMicrophoneDetected: false,
      isSpeakerDetected: false,
      isCalling: false,
      isMute: false,
      isMiniSize: false,
      isShowActionButton: false,
      isShowVoiceWaveIcon: true,
      // isShowPulseAnimation: false,
      isShowWaveAnimation: false,
      isShowMicAnimation: false,
      isLoadingButtonResponseCall: false,

      localStream: null,
      peerConnection: null,
      iceCandidates: [],
      localConnectionCode: null,
      inputCode: '',
      connectionStatus: '', // 'CALLING' | 'ON_CALL' | 'UNANSWERED' | 'REJECTED' | 'CALL_ENDED'
    }
  },
  computed: {
    ...mapState('call', ['callWidget', 'isBalanceAvailable']),
    ...mapState('conversation', [
      'conversationInformation',
      'chatRoomDetails',
      'callPermissionRequest',
    ]),
    ...mapState('organization', ['permissions']),
    isShowButtonResponseIncomingCall() {
      return this.connectionStatus === 'USER_INITIATED'
    },
    isShowButtonMicAndEndCall() {
      return (
        this.connectionStatus === 'CALLING' ||
        this.connectionStatus === 'RINGING' ||
        this.connectionStatus === 'ON_CALL'
      )
    },
    isShowButtonCallAgain() {
      return (
        this.connectionStatus === 'UNANSWERED' ||
        this.connectionStatus === 'REJECTED'
      )
    },
  },
  watch: {
    callWidget: {
      handler(newVal) {
        /**
         * NOTE:
         * Handle when REJECTED or CALL_ENDED is coming first than COMPLETED.
         * Because there is no guarantee that COMPLETED will come first than REJECTED (from META).
         */
        if (this.connectionStatus === 'REJECTED') return
        if (this.connectionStatus === 'CALL_ENDED') return

        const isInboundCall =
          newVal.event_type === 'when_system_send_incoming_calls_webhook'
        const isOutboundCall =
          newVal.event_type === 'when_system_send_calls_webhook'
        const isConnectedEvent = newVal.event === 'connect'
        const hasCallId = !!newVal.id
        const hasSdp = !!(newVal.session && newVal.session.sdp)
        const isAcceptedStatus = newVal.status === 'ACCEPTED'
        const isUnansweredStatus =
          newVal.status === 'COMPLETED' && !newVal.duration
        const isCallEndedStatus =
          newVal.status === 'COMPLETED' && newVal.duration
        const isDeclinedStatus = newVal.status === 'REJECTED'
        const isHideStatus = newVal.status === 'HIDE'

        if (
          isInboundCall &&
          isConnectedEvent &&
          hasCallId &&
          !hasSdp &&
          !isHideStatus
        ) {
          this.isShowCallWidget = true
          this.onInitCallWidget()
          this.checkMicPermission()
        }
        if (isInboundCall && (isUnansweredStatus || isHideStatus)) {
          if (this.audioCalling) {
            this.audioCalling.pause()
            this.audioCalling.currentTime = 0
          }
          this.onResetCallStream()
          this.onStopCallIncoming()
          this.onStopCallDuration()
          this.onStopCallingTimer()
          this.onClickButtonCloseWidget()
          this.isLoadingButtonResponseCall = false
        }

        if (isInboundCall && isAcceptedStatus) {
          this.onHandleSdpAnswer(newVal?.session)
          this.localStream && this.onSetupAnimationByVoice(this.localStream)
          this.onChangeConnectionStatus('ON_CALL')
          this.onStartCallDuration()
          this.isLoadingButtonResponseCall = false
        }
        if (isOutboundCall && isAcceptedStatus) {
          this.onChangeConnectionStatus('ON_CALL')
          this.onStartCallDuration()
          this.isLoadingButtonResponseCall = false
        }
        if (isOutboundCall && isUnansweredStatus) {
          this.onChangeConnectionStatus('UNANSWERED')
        }
        if (isCallEndedStatus) {
          this.onChangeConnectionStatus('CALL_ENDED')
        }
        if (isDeclinedStatus) {
          this.onChangeConnectionStatus('REJECTED')
        }
        if (isOutboundCall && hasSdp && hasCallId && !this.isShowCallWidget) {
          this.isShowCallWidget = true
          this.onInitCallWidget()
          this.onHandleSdpAnswer(newVal.session)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    const isOutboundCall =
      this.callWidget.event_type === 'when_system_send_calls_webhook'
    if (isOutboundCall) {
      this.checkMicPermission()
      this.onStartCall()
    }
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeDestroy() {
    this.onStopCallDuration()
    this.onStopCloseTimer()
    this.onStopCallingTimer()
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  methods: {
    async checkMicPermission() {
      try {
        // Check microphone permission
        const micPerm = await navigator.permissions.query({
          name: 'microphone',
        })
        if (!micPerm) throw new Error(`Empty micPerm`)
        this.microphone.isGranted = micPerm.state === 'granted'
        micPerm.onchange = () => {
          this.microphone.isGranted = micPerm.state === 'granted'
        }
      } catch (error) {
        this.microphone.isGranted = false
        // eslint-disable-next-line no-console
        console.error('checkMicPermission - error:', error)
      }
    },

    // async checkCameraPermission() {
    //   try {
    //     // Check sound (speaker) permission (not directly available, but inferred from audio output)
    //     const camPerm = await navigator.permissions.query({ name: 'camera' })
    //     if (!camPerm) throw new Error(`Empty camPerm`)
    //     this.camera.isGranted = camPerm.state === 'granted'
    //     camPerm.onchange = () => {
    //       this.camera.isGranted = camPerm.state === 'granted'
    //     }
    //   } catch (error) {
    //     this.camera.isGranted = false
    //     // eslint-disable-next-line no-console
    //     console.error('checkCameraPermission - error:', error)
    //   }
    // },
    onInitCallWidget() {
      const isOutboundCall =
        this.callWidget.event_type === 'when_system_send_calls_webhook'
      this.$nextTick(() => {
        this.onCreateAudioElement()
        this.onStartAnimateWidget()
        this.onDragWidget()
        isOutboundCall && this.onSetupAnimationByVoice(this.localStream)
        this.onChangeConnectionStatus(
          isOutboundCall ? 'CALLING' : 'USER_INITIATED'
        )
      })
    },
    generateInitials(fullName) {
      if (!fullName) return ''
      const words = fullName.split(' ')
      const limitedWords = words.slice(0, 2)
      return limitedWords.map((name) => name.charAt(0).toUpperCase()).join('')
    },
    handleBeforeUnload() {
      if (
        navigator.serviceWorker &&
        navigator.serviceWorker.controller &&
        this.callWidget.id &&
        this.callWidget.user.roomId
      ) {
        this.onPostTerminateEndpointViaServiceWorker()
      }
    },
    onPostTerminateEndpointViaServiceWorker() {
      try {
        navigator.serviceWorker.controller.postMessage({
          type: 'wa-call-terminate',
          url: `${CALLS_URL}/wa_cloud/terminate`,
          headers: {
            Authorization: this.$auth.getToken('hub'),
            'Content-Type': 'application/json',
          },
          payload: {
            room_id:
              this.$route.query?.room ?? this.callWidget?.user?.roomId ?? '',
            calls_id: this.callWidget?.id ?? '',
            type: 'calls',
          },
        })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('onPostTerminateEndpointViaServiceWorker:', error)
      }
    },
    async onStartCall() {
      try {
        const userMedia = await this.onSetupUserMedia()
        if (!userMedia) {
          throw new Error('User media is not available')
        }
        this.onCreatePeerConnection()
        this.onSetupTrack()
        const { sdp } = await this.onCreateSdpOffer()
        this.onPostOutboundCall(sdp)
      } catch (error) {
        this.onClickButtonCloseWidget()
      }
    },
    onHandleAudioEffect(connectionStatus) {
      try {
        switch (connectionStatus) {
          case 'USER_INITIATED':
            if (this.audioCallEnded) {
              this.audioCallEnded.pause()
              this.audioCallEnded.currentTime = 0
            }
            this.audioCalling && this.audioCalling.play()
            break
          case 'CALLING':
            if (this.audioCallEnded) {
              this.audioCallEnded.pause()
              this.audioCallEnded.currentTime = 0
            }
            this.audioCalling && this.audioCalling.play()
            break
          case 'ON_CALL':
            if (this.audioCallEnded) {
              this.audioCallEnded.pause()
              this.audioCallEnded.currentTime = 0
            }
            if (this.audioCalling) {
              this.audioCalling.pause()
              this.audioCalling.currentTime = 0
            }
            break
          case 'UNANSWERED':
            if (this.audioCalling) {
              this.audioCalling.pause()
              this.audioCalling.currentTime = 0
            }
            this.audioCallEnded && this.audioCallEnded.play()
            break
          case 'REJECTED':
            if (this.audioCalling) {
              this.audioCalling.pause()
              this.audioCalling.currentTime = 0
            }
            this.audioCallEnded && this.audioCallEnded.play()
            break
          case 'CALL_ENDED':
            if (this.audioCalling) {
              this.audioCalling.pause()
              this.audioCalling.currentTime = 0
            }
            this.audioCallEnded && this.audioCallEnded.play()
            break
          default:
            if (this.audioCalling) {
              this.audioCalling.pause()
              this.audioCalling.currentTime = 0
            }
            if (this.audioCallEnded) {
              this.audioCallEnded.pause()
              this.audioCallEnded.currentTime = 0
            }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onHandleAudioEffect:', error)
      }
    },
    onGenerateConnectionStatusColor(connectionStatus) {
      let result = ''
      switch (connectionStatus) {
        case 'USER_INITIATED':
          result = 'white'
          break
        case 'CALLING':
          result = 'white'
          break
        case 'RINGING':
          result = 'white'
          break
        case 'ON_CALL':
          result = 'green.400'
          break
        case 'UNANSWERED':
          result = 'rose.100'
          break
        case 'REJECTED':
          result = 'rose.100'
          break
        case 'CALL_ENDED':
          result = 'rose.100'
          break
        default:
          result = 'white'
      }
      return result
    },
    onGenerateConnectionStatusName(connectionStatus) {
      let result = ''
      switch (connectionStatus) {
        case 'USER_INITIATED':
          result = 'Incoming call'
          break
        case 'CALLING':
          result = 'Calling...'
          break
        case 'RINGING':
          result = 'Ringing'
          break
        case 'ON_CALL':
          result = 'On call'
          break
        case 'UNANSWERED':
          result = 'Unanswered'
          break
        case 'REJECTED':
          result = 'Declined'
          break
        case 'CALL_ENDED':
          result = 'Call ended'
          break
        default:
          result = 'Calling...'
      }
      return result
    },
    onCreateAudioElement() {
      try {
        this.audioCalling = new Audio('/phone-calling.mp3')
        this.audioCalling.loop = true // Memutar terus-menerus

        this.audioCallEnded = new Audio('/phone-call-ended.mp3')
        this.audioCallEnded.loop = false // Memutar terus-menerus
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onCreateAudioElement:', error)
      }
    },
    // onDecryptConnectionCode(connectionCode) {
    //   try {
    //     const connectionCodeAnswer = JSON.parse(atob(connectionCode))
    //     return connectionCodeAnswer
    //   } catch (error) {
    //     // eslint-disable-next-line no-console
    //     console.error('onDecryptConnectionCode:', error)
    //   }
    // },
    // async onCompleteConnection() {
    //   try {
    //     if (!this.peerConnection) return
    //     const connectionCodeAnswer = this.onDecryptConnectionCode(
    //       this.inputCode
    //     )
    //     if (!connectionCodeAnswer.sdp || !connectionCodeAnswer.type) {
    //       throw new Error('Invalid answer format')
    //     }
    //     await this.peerConnection.setRemoteDescription({
    //       sdp: connectionCodeAnswer.sdp,
    //       type: connectionCodeAnswer.type,
    //     })
    //     for (const candidate of connectionCodeAnswer.candidates) {
    //       await this.peerConnection.addIceCandidate(
    //         new RTCIceCandidate(candidate)
    //       )
    //     }
    //     this.onStartCallDuration()
    //   } catch (error) {
    //     // eslint-disable-next-line no-console
    //     console.error('onCompleteConnection:', error)
    //   }
    // },
    onCreatePeerConnection() {
      try {
        const config = {
          iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
        }
        const pc = new RTCPeerConnection(config)
        if (!pc) return
        this.peerConnection = pc
        this.onSetupPeerConnectionListeners(pc)
        return pc
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onCreatePeerConnection:', error)
      }
    },
    async onSetupUserMedia() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: this.isVideoActive,
        })
        if (!stream) return
        this.localStream = stream
        return stream
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onSetupUserMedia:', error)
        const isMicrophoneNotAllowed = error.message === 'Permission denied'

        // Error toast
        this.$toast({
          variant: 'error',
          title: isMicrophoneNotAllowed
            ? 'Please allow microphone access permission'
            : error.message,
          position: 'top',
          duration: 3000,
        })

        // Store metric to mixpanel
        this.storeMixpanelMetric(
          'Inbox - [WA Call][onSetupUserMedia] Failed to setup user media',
          {
            Role: this.$auth.user.role,
            Email: this.$auth.user.email,
            'Company ID': this.getOrganizationForMetric()['Company ID'],
            'Company Name': this.getOrganizationForMetric()['Company Name'],
            'Room ID': this.$route.query?.room ?? '',
            Error: error?.response ?? error.message ?? error,
          }
        )
      }
    },
    onSetupAnimationByVoice(stream) {
      try {
        if (!(stream instanceof MediaStream)) {
          throw new TypeError(
            '[onSetupAnimationByVoice] Invalid stream: Not a MediaStream object'
          )
        }
        // running pulse animation
        this.onInitPulseAnimation()

        // Create an audio context
        const audioContext = new (window.AudioContext ||
          window.webkitAudioContext)()
        const analyser = audioContext.createAnalyser()
        const source = audioContext.createMediaStreamSource(stream)

        // Connect source to analyser
        source.connect(analyser)

        // Set analyser properties
        analyser.fftSize = 32 // Small FFT for low latency
        const bufferLength = analyser.frequencyBinCount
        const dataArray = new Uint8Array(bufferLength)

        // Update the animation based on audio data
        const updateWave = () => {
          analyser.getByteFrequencyData(dataArray)

          // // Normalize and update levels (scale: 0-100%)
          // const level = Array.from(dataArray.slice(0, 5)).map((value) =>
          //   Math.min((value / 255) * 100, 100)
          // )

          // Calculate average volume
          const volume =
            dataArray.reduce((sum, value) => sum + value, 0) / dataArray.length

          // Threshold for triggering the pulse effect
          const threshold = 50 // Adjust this value as needed

          if (volume > threshold) {
            this.onStartAnimation('pulseAnimation', true)
            this.onStartAnimation('waveAnimation', true)
            // this.onStartAnimation('micAnimation', true)
          } else {
            this.onStartAnimation('waveAnimation', false)
            this.onStartAnimation('pulseAnimation', false)
            // this.onStartAnimation('micAnimation', false)
          }

          requestAnimationFrame(updateWave) // Loop the animation
        }

        updateWave()
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onSetupAnimationByVoice:', error)
      }
    },
    onSetupTrack() {
      try {
        if (this.localStream) {
          this.localStream.getTracks().forEach((track) => {
            this.peerConnection.addTrack(track, this.localStream)

            // push track into device (microphone or speaker) list
            this.device.microphone.list.push({
              id: track?.id ?? '',
              title: track?.label?.split(' - ')?.[0] ?? 'Unknown',
              description: track?.label?.split(' - ')?.[1] ?? 'Unknown',
              value: track?.id ?? '',
            })
            this.device.speaker.list.push({
              id: track?.id ?? '',
              title: track?.label?.split(' - ')?.[0] ?? 'Unknown',
              description: track?.label?.split(' - ')?.[1] ?? 'Unknown',
              value: track?.id ?? '',
            })
          })

          this.device.microphone.list = this.device.microphone.list.map(
            (item) => ({
              ...item,
              title: `System ${item.title}`,
            })
          )
          this.device.speaker.list = this.device.speaker.list.map((item) => ({
            ...item,
            title: `System ${item.title}`,
          }))

          // Auto set default microphone & speaker
          this.isMicrophoneDetected = this.device.microphone.list.length > 0
          this.isSpeakerDetected = this.device.speaker.list.length > 0
          this.onSelectDevice('microphone', this.device.microphone.list[0])
          this.onSelectDevice('speaker', this.device.speaker.list[0])
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onSetupTrack:', error)

        // Error toast
        this.$toast({
          variant: 'error',
          title: error.message,
          position: 'top',
          duration: 3000,
        })

        // Store metric to mixpanel
        this.storeMixpanelMetric(
          'Inbox - [WA Call][onSetupTrack] Failed to setup track and microphone',
          {
            Role: this.$auth.user.role,
            Email: this.$auth.user.email,
            'Company ID': this.getOrganizationForMetric()['Company ID'],
            'Company Name': this.getOrganizationForMetric()['Company Name'],
            'Room ID': this.$route.query?.room ?? '',
            Error: error?.response ?? error.message ?? error,
          }
        )
      }
    },
    onSelectDevice(type, device) {
      this.device[type].value = device.value
      this.device[type].selected = device
    },
    onSetupPeerConnectionListeners(pc) {
      try {
        this.onIceCandidate(pc)
        this.onConnectionStateChange(pc)
        // this.onIceConnectionStateChange(pc)
        this.onTrack(pc)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onSetupPeerConnectionListeners - error:', error)
      }
    },
    onIceCandidate(pc) {
      try {
        pc.onicecandidate = (event) => {
          if (event.candidate) {
            this.iceCandidates.push(event.candidate)
            // this.onGenerateLocalConnectionCode()
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onIceCandidate:', error)
      }
    },
    onConnectionStateChange(pc) {
      try {
        pc.onconnectionstatechange = () => {
          switch (pc.connectionState) {
            case 'connected':
              break
            case 'disconnected':
              this.onChangeConnectionStatus('CALL_ENDED')
              break
            case 'failed':
              this.onChangeConnectionStatus('UNANSWERED')

              break
            case 'closed':
              this.onChangeConnectionStatus('CALL_ENDED')
              break
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onConnectionStateChange:', error)
      }
    },
    onIceConnectionStateChange(pc) {
      try {
        pc.oniceconnectionstatechange = () => {
          if (pc.iceConnectionState === 'disconnected') {
            this.onChangeConnectionStatus('CALL_ENDED')
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onIceConnectionStateChange:', error)
      }
    },
    onTrack(pc) {
      try {
        pc.ontrack = (event) => {
          // if (this.isVideoActive && this.remoteVideoRef) {
          //   this.remoteVideoRef.srcObject = event.streams[0];
          //   return;
          // }

          const remoteStream = new MediaStream()
          event.streams[0].getTracks().forEach((track) => {
            remoteStream.addTrack(track)
          })
          const audioElement = new Audio()
          audioElement.srcObject = remoteStream
          audioElement.play()
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onTrack:', error)
      }
    },
    // onGenerateLocalConnectionCode() {
    //   try {
    //     const data = {
    //       sdp: this.peerConnection?.localDescription?.sdp,
    //       type: this.peerConnection?.localDescription?.type,
    //       candidates: this.iceCandidates,
    //     }
    //     this.localConnectionCode = btoa(JSON.stringify(data))
    //   } catch (error) {
    //     // eslint-disable-next-line no-console
    //     console.error('onGenerateLocalConnectionCode - error', error)
    //   }
    // },
    async onCreateSdpOffer() {
      try {
        const offerOptions = {
          offerToReceiveAudio: 1,
          offerToReceiveVideo: 0,
        }
        const offerCode = await this.peerConnection.createOffer(offerOptions)
        await this.peerConnection.setLocalDescription(offerCode)
        return offerCode
      } catch (error) {
        // Store metric to mixpanel
        this.storeMixpanelMetric(
          'Inbox - [WA Call][WebRTC][API][onCreateSdpOffer] failed to create sdp offer',
          {
            Role: this.$auth.user.role,
            Email: this.$auth.user.email,
            'Company ID': this.getOrganizationForMetric()['Company ID'],
            'Company Name': this.getOrganizationForMetric()['Company Name'],
            'Room ID': this.$route.query?.room ?? '',
            Error: error ?? '',
          }
        )
      }
    },
    async onPostOutboundCall(sdpOffer) {
      try {
        const CONFIG = {
          headers: {
            Authorization: validTokenCookie(),
          },
          timeout: 20000,
        }

        const PAYLOAD_VOICE = {
          direction: 'outbound',
          channel_integration_id:
            this.conversationInformation?.channelIntegrationId ?? '',
          sdp: sdpOffer ?? this.peerConnection?.localDescription.sdp ?? '',
          contact_phone_number:
            this.conversationInformation?.uniqueAccount ?? '',
          channel_phone_number:
            this.findServerChannelIntegrationId(
              this.chatRoomDetails.channelIntegrationId
            ) || '',
          room_id: this.$route.query?.room ?? '',
        }
        const PAYLOAD_CHAT = {
          room_id: this.$route.query?.room ?? '',
          type: 'calls',
          sdp: this.peerConnection?.localDescription?.sdp ?? '',
        }
        const PAYLOAD = this.permissions.wa_call_use_voice_service
          ? PAYLOAD_VOICE
          : PAYLOAD_CHAT

        if (
          this.permissions.wa_call_use_voice_service &&
          !PAYLOAD.channel_integration_id
        )
          throw new Error('channel_integration_id is required')
        if (
          this.permissions.wa_call_use_voice_service &&
          !PAYLOAD.channel_phone_number
        )
          throw new Error('channel_phone_number is required')
        if (
          this.permissions.wa_call_use_voice_service &&
          !PAYLOAD.contact_phone_number
        )
          throw new Error('contact_phone_number is required')
        if (this.permissions.wa_call_use_voice_service && !PAYLOAD.sdp)
          throw new Error('sdp_offer is required')

        const ENDPOINT_VOICE = `${CALLS_VOICE_URL}/wa_cloud/calls`
        const ENDPOINT_CHAT = `${CALLS_URL}/wa_cloud`
        const ENDPOINT = this.permissions.wa_call_use_voice_service
          ? ENDPOINT_VOICE
          : ENDPOINT_CHAT

        const {
          data: { data },
        } = await this.$axios.post(ENDPOINT, PAYLOAD, CONFIG)

        if (this.permissions.wa_call_use_voice_service) {
          const isAvailableExternalId = data.externalID
          const isAvailableSession = data.session
          if (isAvailableExternalId && isAvailableSession) {
            this.$store.commit('call/UPDATE_CALL_WIDGET', {
              id: data?.externalID ?? '',
              session: {
                sdp: data?.session?.sdp ?? '',
                sdp_type: data?.session?.type ?? '',
              },
            })
          } else {
            // Store metric to mixpanel
            this.storeMixpanelMetric(
              'Inbox - [WA Call][WebRTC][API][onPostOutboundCall] No externalID or session from voice/v1/wa_cloud/calls',
              {
                Role: this.$auth.user.role,
                Email: this.$auth.user.email,
                'Company ID': this.getOrganizationForMetric()['Company ID'],
                'Company Name': this.getOrganizationForMetric()['Company Name'],
                'Room ID': this.$route.query?.room ?? '',
                Error: data ?? '',
              }
            )
          }
        }

        if (!this.permissions.wa_call_use_voice_service) {
          const isAvailableData = data
          const isAvailableCallResponse = data.calls_response
          const isAvailableCallResponseId = data.calls_response.id

          if (
            isAvailableData &&
            isAvailableCallResponse &&
            isAvailableCallResponseId
          ) {
            this.$store.commit('call/UPDATE_CALL_WIDGET', {
              id: data?.calls_response?.id ?? '',
            })
          } else {
            // Store metric to mixpanel
            this.storeMixpanelMetric(
              'Inbox - [WA Call][WebRTC][API][onPostOutboundCall] No calls_response.id from v1/calls/wa_cloud',
              {
                Role: this.$auth.user.role,
                Email: this.$auth.user.email,
                'Company ID': this.getOrganizationForMetric()['Company ID'],
                'Company Name': this.getOrganizationForMetric()['Company Name'],
                'Room ID': this.$route.query?.room ?? '',
                Error: data ?? '',
              }
            )
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onPostOutboundCall:', error)

        // Force close widget without onStartCloseTimer
        this.onResetCallStream()
        this.onStopCallDuration()
        this.onClickButtonCloseWidget()

        const errorCode = error?.response?.data?.code ?? error?.response?.status
        const errorMessage =
          error.response?.data?.error?.messages?.[0] ??
          error.response?.data?.error_description ??
          error.response?.data?.errors ??
          error.message ??
          ''
        const isErrorMessageContainBalance =
          errorMessage.includes('balance') || false
        const isErrorInsufficientBalance =
          errorCode === 402 && isErrorMessageContainBalance

        if (!isErrorInsufficientBalance) {
          // Error toast
          this.$toast({
            variant: 'error',
            title:
              error.response?.data?.error?.messages?.[0] ??
              error?.response?.data?.error_description ??
              error?.response?.data?.errors ??
              error.message,
            position: 'top',
            duration: 3000,
          })

          // Store metric to mixpanel
          this.storeMixpanelMetric(
            'Inbox - [WA Call][WebRTC][API][onPostOutboundCall] Failed create and send SDP Offer',
            {
              Role: this.$auth.user.role,
              Email: this.$auth.user.email,
              'Company ID': this.getOrganizationForMetric()['Company ID'],
              'Company Name': this.getOrganizationForMetric()['Company Name'],
              'Room ID': this.$route.query?.room ?? '',
              Error: error?.response ?? error.message ?? error,
            }
          )
        } else {
          this.$store.commit(
            'call/UPDATE_CALL_BALANCE',
            !this.isBalanceAvailable
          )

          // Store metric to mixpanel
          this.storeMixpanelMetric(
            'Inbox - [WA Call][WebRTC][API][onPostOutboundCall] Insufficient voice balance',
            {
              Role: this.$auth.user.role,
              Email: this.$auth.user.email,
              'Company ID': this.getOrganizationForMetric()['Company ID'],
              'Company Name': this.getOrganizationForMetric()['Company Name'],
              'Room ID': this.$route.query?.room ?? '',
              Error: error?.response ?? error.message ?? error,
            }
          )
        }
      }
    },
    async onHandleSdpAnswer(session) {
      try {
        if (!this.peerConnection) return
        if (this.peerConnection.signalingState === 'stable') return
        await this.peerConnection.setRemoteDescription({
          sdp: session.sdp,
          type: session?.sdp_type ?? 'answer',
        })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onHandleSdpAnswer:', error)

        // Store metric to mixpanel
        this.storeMixpanelMetric(
          'Inbox - [WA Call][WebRTC][onHandleSdpAnswer] Failed to handle SDP Answer',
          {
            Role: this.$auth.user.role,
            Email: this.$auth.user.email,
            'Company ID': this.getOrganizationForMetric()['Company ID'],
            'Company Name': this.getOrganizationForMetric()['Company Name'],
            'Room ID': this.$route.query?.room ?? '',
            Error: error?.response ?? error.message ?? error,
          }
        )
      }
    },
    // async onCreateSdpOffer() {
    //   try {
    //     if (!this.data.connectionCodeOffer) this.connectionStatus = 'CALLING'
    //     const offerCode = await this.peerConnection.createOffer()
    //     await this.peerConnection.setLocalDescription(offerCode)
    //     this.onGenerateLocalConnectionCode()
    //     // const payload = {
    //     //   room_id: this.$route.query.room || '',
    //     //   type: 'calls',
    //     //   sdp: this.peerConnection?.localDescription.sdp,
    //     // }
    //     // const additional = {
    //     //   headers: {
    //     //     Authorization: validTokenCookie(),
    //     //   },
    //     // }
    //     // if (!payload.room_id) throw new Error('Room ID is required')
    //     // await this.$axios.post(`${CALLS_URL}/wa_cloud`, payload, additional)
    //   } catch (error) {
    //     // eslint-disable-next-line no-console
    //     console.error('onCreateSdpOffer:', error)
    //     onChangeConnectionStatus('UNANSWERED')
    //     // this.onClickButtonEndCall()
    //     this.$toast({
    //       variant: 'error',
    //       title: error.response?.data?.error?.messages?.[0] ?? error.message,
    //       position: 'top',
    //       duration: 3000,
    //     })
    //     this.storeMixpanelMetric('Inbox - [API] Failed to send SDP Offer', {
    //       Role: this.$auth.user.role,
    //       Email: this.$auth.user.email,
    //       'Company ID': this.getOrganizationForMetric()['Company ID'],
    //       'Company Name': this.getOrganizationForMetric()['Company Name'],
    //       'Room ID': this.$route.query?.room ?? '',
    //       Error: error.response?.data?.error?.messages?.[0] ?? error.message,
    //     })
    //   }
    // },
    // async onCreateSdpAnswer() {
    //   try {
    //     const code = this.onDecryptConnectionCode(this.data.connectionCodeOffer)
    //     if (!code.sdp || !code.type) {
    //       throw new Error('Invalid answer format')
    //     }
    //     await this.peerConnection.setRemoteDescription({
    //       sdp: code.sdp,
    //       type: code.type,
    //     })
    //     for (const candidate of code.candidates) {
    //       await this.peerConnection.addIceCandidate(
    //         new RTCIceCandidate(candidate)
    //       )
    //     }
    //     const answerCode = await this.peerConnection.createAnswer()
    //     await this.peerConnection.setLocalDescription(answerCode)
    //     this.onGenerateLocalConnectionCode()
    //     this.onStartCallDuration()
    //   } catch (error) {
    //     // eslint-disable-next-line no-console
    //     console.error('onCreateSdpAnswer:', error)
    //     this.$toast({
    //       variant: 'error',
    //       title: error.response?.data?.error?.messages?.[0] ?? error.message,
    //       position: 'top',
    //       duration: 3000,
    //     })
    //     this.storeMixpanelMetric('Inbox - [API] Failed to send SDP Answer', {
    //       Role: this.$auth.user.role,
    //       Email: this.$auth.user.email,
    //       'Company ID': this.getOrganizationForMetric()['Company ID'],
    //       'Company Name': this.getOrganizationForMetric()['Company Name'],
    //       'Room ID': this.$route.query?.room ?? '',
    //       Error: error.response?.data?.error?.messages?.[0] ?? error.message,
    //     })
    //   }
    // },
    onClickButtonEndCall() {
      try {
        if (!this.callWidget.id) return
        this.onChangeConnectionStatus('CALL_ENDED')
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onClickButtonEndCall:', error)

        // Store metric to mixpanel
        this.storeMixpanelMetric(
          'Inbox - [WA Call][onClickButtonEndCall] Failed to end call',
          {
            Role: this.$auth.user.role,
            Email: this.$auth.user.email,
            'Company ID': this.getOrganizationForMetric()['Company ID'],
            'Company Name': this.getOrganizationForMetric()['Company Name'],
            'Room ID': this.$route.query?.room ?? '',
            Error: error?.response ?? error.message ?? error,
          }
        )
      }
    },
    onResetCallStream() {
      this.onResetLocalStream()
      this.onResetPeerConnection()
      this.onResetRemoteStream()
    },
    async onPostTerminateEndpoint() {
      try {
        const CONFIG = {
          headers: {
            Authorization: validTokenCookie(),
          },
        }
        const PAYLOAD_CHAT = {
          room_id:
            this.$route.query?.room ?? this.callWidget?.user?.roomId ?? '',
          calls_id: this.callWidget?.id ?? '',
          type: 'calls',
        }
        const PAYLOAD_VOICE = {
          channel_integration_id:
            this.callWidget?.channel_integration_id ??
            this.conversationInformation?.channelIntegrationId,
          external_id: this.callWidget?.id ?? '',
        }
        const PAYLOAD = this.permissions.wa_call_use_voice_service
          ? PAYLOAD_VOICE
          : PAYLOAD_CHAT
        const ENDPOINT_VOICE = `${CALLS_VOICE_URL}/wa_cloud/calls/terminate`
        const ENDPOINT_CHAT = `${CALLS_URL}/wa_cloud/terminate`
        const ENDPOINT = this.permissions.wa_call_use_voice_service
          ? ENDPOINT_VOICE
          : ENDPOINT_CHAT

        await this.$axios.post(ENDPOINT, PAYLOAD, CONFIG)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onPostTerminateEndpoint:', error)

        // Store metric to mixpanel
        this.storeMixpanelMetric(
          'Inbox - [WA Call][API][onPostTerminateEndpoint] Failed to post into terminate call endpoint',
          {
            Role: this.$auth.user.role,
            Email: this.$auth.user.email,
            'Company ID': this.getOrganizationForMetric()['Company ID'],
            'Company Name': this.getOrganizationForMetric()['Company Name'],
            'Room ID': this.$route.query?.room ?? '',
            Error: error?.response ?? error.message ?? error,
          }
        )
      }
    },
    onResetPeerConnection() {
      try {
        if (this.peerConnection) {
          this.peerConnection.close()
          this.peerConnection = null
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onResetPeerConnection:', error)
      }
    },
    onResetLocalStream() {
      try {
        if (this.localStream) {
          this.localStream.getTracks().forEach((track) => {
            track.stop()
            track.enabled = false
          })
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onResetLocalStream - error:', error)
      }
    },
    onResetRemoteStream() {
      try {
        // remove src on audio local stream and remote stream
        const remoteAudioElement = document.querySelector('audio')
        if (remoteAudioElement && remoteAudioElement.srcObject) {
          const remoteStream = remoteAudioElement.srcObject
          remoteStream.getTracks().forEach((track) => track.stop())
          remoteAudioElement.srcObject = null
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onResetRemoteStream:', error)
      }
    },
    onClickButtonMuteUnmute() {
      try {
        if (this.connectionStatus !== 'ON_CALL') {
          // eslint-disable-next-line no-console
          console.error(
            '[onClickButtonMuteUnmute] connectionStatus is not on call'
          )
          return
        }
        this.localStream.getAudioTracks().forEach((track) => {
          track.enabled = this.microphone.isMuted
        })
        this.microphone.isMuted = !this.microphone.isMuted
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onButtonMuteClicked:', error)

        // Store metric to mixpanel
        this.storeMixpanelMetric(
          'Inbox - [WA Call][onClickButtonMuteUnmute] Failed to mute microphone',
          {
            Role: this.$auth.user.role,
            Email: this.$auth.user.email,
            'Company ID': this.getOrganizationForMetric()['Company ID'],
            'Company Name': this.getOrganizationForMetric()['Company Name'],
            'Room ID': this.$route.query?.room ?? '',
            Error: error?.response ?? error.message ?? error,
          }
        )
      }
    },
    onClickButtonMinimize() {
      this.isMiniSize = !this.isMiniSize

      this.$nextTick(() => {
        this.onStartAnimateWidget()
      })
      this.$emit('minimize', this.isMiniSize)
    },
    onClickButtonFullScreen() {
      alert('Go to fullscreen')
      this.$emit('full-screen')
    },
    async onClickButtonDeclineCall() {
      try {
        this.isLoadingButtonResponseCall = true
        const isUsingVoiceService = this.permissions.wa_call_use_voice_service
        if (!isUsingVoiceService) return
        const CONFIG = {
          headers: {
            Authorization: validTokenCookie(),
          },
        }
        const PAYLOAD = {
          channel_integration_id: this.callWidget?.channel_integration_id ?? '',
          room_id: this.callWidget?.room_id ?? '',
          external_id: this.callWidget?.id ?? '',
        }
        if (!PAYLOAD.channel_integration_id)
          throw new Error('channel_integration_id is required as payload')
        if (!PAYLOAD.room_id) throw new Error('room_id is required as payload')
        if (!PAYLOAD.external_id)
          throw new Error('external_id is required as payload')

        await this.$axios.post(
          `${CALLS_VOICE_URL}/wa_cloud/calls/reject`,
          PAYLOAD,
          CONFIG
        )

        if (this.audioCalling) {
          this.audioCalling.pause()
          this.audioCalling.currentTime = 0
        }
        this.onResetCallStream()
        this.onStopCallIncoming()
        this.onStopCallDuration()
        this.onStopCallingTimer()
        this.onClickButtonCloseWidget()
        this.isLoadingButtonResponseCall = false
      } catch (error) {
        this.isLoadingButtonResponseCall = false
        // eslint-disable-next-line no-console
        console.error('onClickButtonDeclineCall:', error)

        // Error toast
        this.$toast({
          variant: 'error',
          title:
            error.response?.data?.error?.messages?.[0] ??
            error?.response?.data?.error_description ??
            error?.response?.data?.message ??
            error?.response?.data?.error ??
            error?.response?.data?.errors,
          position: 'top',
          duration: 3000,
        })

        // Store metric to mixpanel
        this.storeMixpanelMetric(
          'Inbox - [WA Call][API][onClickButtonDeclineCall] Failed to post into decline call endpoint from incoming call',
          {
            Role: this.$auth.user.role,
            Email: this.$auth.user.email,
            'Company ID': this.getOrganizationForMetric()['Company ID'],
            'Company Name': this.getOrganizationForMetric()['Company Name'],
            'Room ID': this.$route.query?.room ?? '',
            Error: error?.response ?? error.message ?? error,
          }
        )
      }
    },
    async onClickButtonAcceptCall() {
      try {
        this.isLoadingButtonResponseCall = true
        const isUsingVoiceService = this.permissions.wa_call_use_voice_service
        if (!isUsingVoiceService) return
        const userMedia = await this.onSetupUserMedia()
        if (!userMedia) throw new Error('User media is not available')
        this.onCreatePeerConnection()
        this.onSetupTrack()
        const { sdp } = await this.onCreateSdpOffer()
        this.onPostAcceptCall(sdp)
      } catch (error) {
        this.isLoadingButtonResponseCall = false
        // eslint-disable-next-line no-console
        console.error('onClickButtonAcceptCall:', error)

        // Store metric to mixpanel
        this.storeMixpanelMetric(
          'Inbox - [WA Call][API][onClickButtonAcceptCall] Failed to handle peer connection, audio and setup track',
          {
            Role: this.$auth.user.role,
            Email: this.$auth.user.email,
            'Company ID': this.getOrganizationForMetric()['Company ID'],
            'Company Name': this.getOrganizationForMetric()['Company Name'],
            'Room ID': this.$route.query?.room ?? '',
            Error: error?.response ?? error.message ?? error,
          }
        )
      }
    },
    async onPostAcceptCall(sdpOffer) {
      try {
        const CONFIG = {
          headers: {
            Authorization: validTokenCookie(),
          },
        }

        const PAYLOAD = {
          direction: 'inbound',
          channel_integration_id: this.callWidget?.channel_integration_id ?? '',
          room_id: this.callWidget?.room_id ?? '',
          external_id: this.callWidget?.id ?? '',
          channel_phone_number: this.callWidget?.channel_phone_number ?? '',
          contact_phone_number: this.callWidget?.contact_phone_number ?? '',
          sdp: sdpOffer ?? this.peerConnection?.localDescription?.sdp ?? '',
        }
        if (!PAYLOAD.channel_integration_id)
          throw new Error('channel_integration_id is required as payload')
        if (!PAYLOAD.room_id) throw new Error('room_id is required as payload')
        if (!PAYLOAD.external_id)
          throw new Error('external_id is required as payload')
        if (!PAYLOAD.channel_phone_number)
          throw new Error('channel_phone_number is required as payload')
        if (!PAYLOAD.contact_phone_number)
          throw new Error('contact_phone_number is required as payload')
        if (!PAYLOAD.sdp) throw new Error('sdp is required as payload')

        const {
          data: { data },
        } = await this.$axios.post(
          `${CALLS_VOICE_URL}/wa_cloud/calls/accept`,
          PAYLOAD,
          CONFIG
        )

        const isAvailableExternalId = data?.externalID ?? ''
        const isAvailableSession = data?.session ?? ''
        if (isAvailableExternalId && isAvailableSession) {
          this.$store.commit('call/UPDATE_CALL_WIDGET', {
            id: data?.externalID ?? '',
            session: {
              sdp: data?.session?.sdp ?? '',
              sdp_type: data?.session?.type ?? '',
            },
          })
        } else {
          // Store metric to mixpanel
          this.storeMixpanelMetric(
            'Inbox - [WA Call][WebRTC][API][onPostAcceptCall] No externalID or session from voice/v1/wa_cloud/calls',
            {
              Role: this.$auth.user.role,
              Email: this.$auth.user.email,
              'Company ID': this.getOrganizationForMetric()['Company ID'],
              'Company Name': this.getOrganizationForMetric()['Company Name'],
              'Room ID': this.$route.query?.room ?? '',
              Error: data ?? '',
            }
          )
        }
      } catch (error) {
        this.isLoadingButtonResponseCall = false
        // eslint-disable-next-line no-console
        console.error('onPostAcceptCall:', error)

        // Error toast
        this.$toast({
          variant: 'error',
          title:
            error.response?.data?.error?.messages?.[0] ??
            error?.response?.data?.error_description ??
            error?.response?.data?.message ??
            error?.response?.data?.error ??
            error?.response?.data?.errors,
          position: 'top',
          duration: 3000,
        })

        // Store metric to mixpanel
        this.storeMixpanelMetric(
          'Inbox - [WA Call][API][onPostAcceptCall] Failed to post into accept call endpoint',
          {
            Role: this.$auth.user.role,
            Email: this.$auth.user.email,
            'Company ID': this.getOrganizationForMetric()['Company ID'],
            'Company Name': this.getOrganizationForMetric()['Company Name'],
            'Room ID': this.$route.query?.room ?? '',
            Error: error?.response ?? error.message ?? error,
          }
        )
      }
    },
    onClickButtonCallAgain() {
      this.$store.commit('call/UPDATE_CALL_WIDGET', {
        phoneNumberId: '',
        session: '',
        status: '',
        id: '',
        event: '',
        event_id: '',
        event_type: 'when_system_send_calls_webhook',
        message_id: '',
        phone_number_id: '',
        to: '',
        isShow: false,
        timestamp: false,
        duration: '',
      })
      this.connectionStatus = ''
      this.isShowCallWidget = false
      this.onStopCloseTimer()
      this.onStartCall()
    },
    onStartAnimation(type, value) {
      // pulse animation
      if (type === 'pulseAnimation' && value) {
        this.onInitPulseAnimation(true)
      }
      if (type === 'pulseAnimation' && !value) {
        this.onInitPulseAnimation(false)
      }

      // wave animation
      if (type === 'waveAnimation' && value) {
        this.isShowWaveAnimation = true
      }
      if (type === 'waveAnimation' && !value) {
        this.isShowWaveAnimation = false
      }

      // mic animation
      if (type === 'micAnimation' && value) {
        this.isShowMicAnimation = true
      }
      if (type === 'micAnimation' && !value) {
        this.isShowMicAnimation = false
      }
    },
    onInitPulseAnimation(isStart) {
      if (isStart === undefined) {
        this.pulseAnimation = anime({
          targets: this.$refs.pulseCircle.$el,
          scale: [0, 1.5],
          opacity: [1, 0],
          easing: 'easeOutSine',
          duration: 1200,
          loop: false,
          autoplay: false,
        })
      }
      isStart && this.pulseAnimation.play()
    },
    onStartAnimateWidget() {
      anime({
        targets: this.$refs?.widget?.$el ?? '',
        opacity: [0, 1],
        translateY: this.isMiniSize ? [-80, 0] : [160, 0],
        width: this.isMiniSize
          ? [this.widthDefaultWidget, this.widthMiniWidget]
          : [this.widthMiniWidget, this.widthDefaultWidget],
        easing: 'easeOutSine',
        duration: 200,
        delay: 50,
      })
    },
    onDragWidget() {
      this.dragEl = document.querySelector('#drag-element')
      this.containerEl = document.querySelector('.mp-main-body')
      this.handleEl = document.querySelector('#drag-handle')

      if (this.dragEl && this.containerEl && this.handleEl) {
        this.drag = new Draggable(this.dragEl, {
          defaultPosition: { x: 0, y: 0 },
          axis: 'both',
          handle: this.handleEl,
          bounds: this.containerEl,
        })
      }
    },
    onStartCallIncoming() {
      this.callIncoming.timer = setInterval(() => {
        this.callIncoming.seconds += 1 // Increment seconds
        this.callIncoming.value = this.onFormatTime(this.callIncoming.seconds)
      }, 1000)
    },
    onStopCallIncoming() {
      this.onStartAnimation('pulseAnimation', false)
      this.onStartAnimation('waveAnimation', false)
      clearInterval(this.callIncoming.timer)
      this.callIncoming.timer = null
    },
    onStartCallDuration() {
      if (this.callDuration.timer) this.onStopCallDuration()
      this.callDuration.timer = setInterval(() => {
        this.callDuration.seconds += 1 // Increment seconds
        this.callDuration.value = this.onFormatTime(this.callDuration.seconds)
      }, 1000)
    },
    onStopCallDuration() {
      this.onStartAnimation('pulseAnimation', false)
      this.onStartAnimation('waveAnimation', false)
      clearInterval(this.callDuration.timer)
      this.callDuration.timer = null
    },
    onStartCloseTimer() {
      this.closeTimer.seconds = 15
      this.closeTimer.timer = setInterval(() => {
        this.closeTimer.seconds -= 1 // Decrement seconds
        if (this.closeTimer.seconds < 0) {
          this.onClickButtonCloseWidget()
        }
      }, 1000)
    },
    onStopCloseTimer() {
      clearInterval(this.closeTimer.timer)
      this.closeTimer.timer = null
    },
    onStartCallingTimer() {
      this.callingTimer.seconds = 15
      this.callingTimer.timer = setInterval(() => {
        this.callingTimer.seconds -= 1 // Decrement seconds
        if (this.connectionStatus === 'ON_CALL') {
          this.onStopCallingTimer()
        }
        if (
          this.callingTimer.seconds < 0 ||
          this.connectionStatus === 'UNANSWERED'
        ) {
          this.onChangeConnectionStatus('UNANSWERED')
        }
      }, 1000)
    },
    onStopCallingTimer() {
      clearInterval(this.callingTimer.timer)
      this.callingTimer.timer = null
    },
    onFormatTime(seconds) {
      const minutes = Math.floor(seconds / 60)
      const secs = seconds % 60
      return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(
        2,
        '0'
      )}`
    },
    onClickButtonCloseWidget() {
      this.onStopCloseTimer()
      this.$store.commit('call/UPDATE_CALL_WIDGET', {
        user: {
          avatar: '',
          fullname: '',
          phone: '',
          roomId: '',
        },
        phoneNumberId: '',
        session: '',
        status: '',
        id: '',
        event: '',
        event_id: '',
        event_type: '',
        message_id: '',
        phone_number_id: '',
        to: '',
        isShow: false,
        timestamp: false,
        duration: '',
      })
      this.audioCalling = null
      this.audioCallEnded = null
    },
    async onChangeConnectionStatus(status) {
      try {
        switch (status) {
          case 'USER_INITIATED':
            this.connectionStatus = 'USER_INITIATED'
            this.icon.transform = 'rotate(0deg)'
            this.onHandleAudioEffect('USER_INITIATED')
            this.onStartCallIncoming()
            break
          case 'CALLING':
            this.connectionStatus = 'CALLING'
            this.icon.transform = 'rotate(0deg)'
            this.onHandleAudioEffect('CALLING')
            break
          // case 'RINGING':
          //   this.connectionStatus = 'RINGING'
          //   break
          case 'ON_CALL':
            this.connectionStatus = 'ON_CALL'
            this.icon.transform = 'rotate(0deg)'
            this.onHandleAudioEffect('ON_CALL')
            this.onStopCallIncoming()
            break
          case 'UNANSWERED':
            this.connectionStatus = 'UNANSWERED'
            this.icon.transform = 'rotate(135deg)'
            this.onHandleAudioEffect('UNANSWERED')
            this.onResetCallStream()
            this.onStopCallDuration()
            this.onStopCallingTimer()
            this.onStopCloseTimer()
            this.onStartCloseTimer()
            break
          case 'REJECTED':
            this.connectionStatus = 'REJECTED'
            this.icon.transform = 'rotate(135deg)'
            this.onHandleAudioEffect('REJECTED')
            this.onResetCallStream()
            this.onStopCallDuration()
            this.onStopCallingTimer()
            this.onStopCloseTimer()
            this.onStartCloseTimer()
            this.onCheckingFetchCallPermissionRequest()
            break
          case 'CALL_ENDED':
            this.connectionStatus = 'CALL_ENDED'
            this.icon.transform = 'rotate(135deg)'
            this.onHandleAudioEffect('CALL_ENDED')
            this.onStopCallingTimer()
            // call endpoint terminate - no matter endpoint status code
            await this.onPostTerminateEndpoint()
            this.onResetCallStream()
            this.onStopCallDuration()
            this.onStopCloseTimer()
            this.onStartCloseTimer()
            this.onCheckingFetchCallPermissionRequest()
            break
          default:
            this.connectionStatus = 'CALLING'
            break
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('onChangeConnectionStatus:', error)

        // // Error toast
        // this.$toast({
        //   variant: 'error',
        //   title: error.message,
        //   position: 'top',
        //   duration: 3000,
        // })

        // // Store metric to mixpanel
        // this.storeMixpanelMetric(
        //   'Inbox - [onChangeConnectionStatus] Failed to change connection status',
        //   {
        //     Role: this.$auth.user.role,
        //     Email: this.$auth.user.email,
        //     'Company ID': this.getOrganizationForMetric()['Company ID'],
        //     'Company Name': this.getOrganizationForMetric()['Company Name'],
        //     'Room ID': this.$route.query?.room ?? '',
        //     Error: error?.message ?? error,
        //   }
        // )
      }
    },
    onCheckingFetchCallPermissionRequest() {
      const isChannelWhatsapp =
        this.conversationInformation.channel === 'wa' ||
        this.conversationInformation.channel === 'wa_cloud'
      const IsRoomStatusNotResolved =
        this.conversationInformation.status !== 'resolved'
      const IsRoomSessionNotExpired =
        this.conversationInformation.session !== 'expired'

      if (
        isChannelWhatsapp &&
        IsRoomStatusNotResolved &&
        IsRoomSessionNotExpired
      ) {
        const params = {
          room_id: this.$route.query?.room ?? '',
          contact_id:
            this.callPermissionRequest.childContact?.id ??
            this.callPermissionRequest?.contactId ??
            '',
        }
        this.fetchCheckingCallPermissionLimit(params)
      }
    },
    async fetchCheckingCallPermissionLimit(params) {
      try {
        if (!params.room_id) {
          // eslint-disable-next-line no-console
          console.error('room_id is required')
          return
        }
        if (!params.contact_id) {
          // eslint-disable-next-line no-console
          console.error('contact_id is required')
          return
        }
        const additional = {
          headers: {
            Authorization: validTokenCookie(),
          },
        }
        const {
          data: { data },
        } = await this.$axios.get(
          `${CALLS_URL}/call_permission_request/limit`,
          { params },
          additional
        )
        this.$store.commit('call/UPDATE_CALL_PERMISSION', data.is_limit)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('fetchCheckingCallPermissionLimit]:', error)
        // Store metric to mixpanel
        this.storeMixpanelMetric(
          'Inbox - [WA Call][API][fetchCheckingCallPermissionLimit] failed fetch api after end call',
          {
            Role: this.$auth.user.role,
            Email: this.$auth.user.email,
            'Company ID': this.getOrganizationForMetric()['Company ID'],
            'Company Name': this.getOrganizationForMetric()['Company Name'],
            'Room ID': this.$route.query?.room ?? '',
            Error:
              error.response?.data?.error?.messages?.[0] ??
              error?.message ??
              error,
          }
        )
      }
    },
  },
}
</script>
